import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
const DevelopersPage = lazy(() => import('./DevelopersPage'))
const DevelopersOverview = lazy(() => import('./DevelopersOverview/DevelopersOverview'))
const DevelopersCredential = lazy(() => import('./DevelopersCredential/DevelopersCredential'))
const AccessTokenForm = lazy(() => import('features/access-token/ui/AccessTokenForm/AccessTokenForm'))
const SpaForm = lazy(() => import('./DevelopersCredential/OAuthClients/OAuthClientsForm/SpaForm/SpaForm'))
const M2MForm = lazy(() => import('./DevelopersCredential/OAuthClients/OAuthClientsForm/M2MForm/M2MForm'))
const DevelopersWorkflows = lazy(() => import('./DevelopersWorkflows/DevelopersWorkflows'))
const DevelopersNamedSources = lazy(() => import('./DevelopersNamedSources/DevelopersNamedSources'))
const NamedSourcesForm = lazy(() => import('./DevelopersNamedSources/NamedSourcesForm/NamedSourcesForm'))

const routes = {
  path: 'developers',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<DevelopersPage />} />
    </LazyLoad>
  ),
  children: [
    {
      index: true,
      element: (
        <LazyLoad>
          <DevelopersOverview />
        </LazyLoad>
      )
    },
    {
      path: 'credentials',
      element: (
        <LazyLoad>
          <DevelopersCredential />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/create/token',
      element: (
        <LazyLoad>
          <AccessTokenForm />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/token/:id',
      element: (
        <LazyLoad>
          <AccessTokenForm />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/create/spa',
      element: (
        <LazyLoad>
          <SpaForm />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/spa/:id',
      element: (
        <LazyLoad>
          <SpaForm />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/create/m2m',
      element: (
        <LazyLoad>
          <M2MForm />
        </LazyLoad>
      )
    },
    {
      path: 'credentials/m2m/:id',
      element: (
        <LazyLoad>
          <M2MForm />
        </LazyLoad>
      )
    },
    {
      path: 'named-sources',
      element: (
        <LazyLoad>
          <DevelopersNamedSources />
        </LazyLoad>
      )
    },
    {
      path: 'named-sources/create',
      element: (
        <LazyLoad>
          <NamedSourcesForm />
        </LazyLoad>
      )
    },
    {
      path: 'named-sources/:name',
      element: (
        <LazyLoad>
          <NamedSourcesForm />
        </LazyLoad>
      )
    },
    {
      path: 'workflows',
      element: (
        <LazyLoad>
          <DevelopersWorkflows />
        </LazyLoad>
      )
    }
  ]
}

export default routes
